import { isNullish } from 'helpers/objects';
import { NBXMarkets } from 'services';
import buildTradeId from 'helpers/buildTradeId';

const fetchInitDataToRawData = async (pair, limit) => {
  const res = await NBXMarkets.getMarketTrades(pair);

  if (res.body.length < limit && !isNullish(res.nextPageUrl)) {
    const nextPageRes = await NBXMarkets.getMarketTrades(pair, res.nextPageUrl);
    res.body.push(...nextPageRes.body);
  }

  return res.body.map(trade => ({
    ...trade,
    tradeId: buildTradeId(trade.makerOrder.id, trade.takerOrder.id)
  }));
};

export default fetchInitDataToRawData;
